import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import Button from '@mui/material/Button';
import makeStyles from '@mui/styles/makeStyles';
import { useIntl, FormattedMessage } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { SubscriptionSource, TestResultCount, UsagePlan } from '../../models';
import { ReactComponent as TestOpsIcon } from '../icons/testops.svg';
import { resolvePath, sso } from '../../routes';
import { UNLIMITED_EXECUTIONS, DEFAULT_EXECUTIONS } from './utils';
import { useConfig } from '../../config';

const useStyles = makeStyles(theme => ({
  testopsLicenseContainer: {
    marginTop: theme.spacing(4.5),
    padding: theme.spacing(2, 2),
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  testopsIcon: {
    marginRight: theme.spacing(1),
  },
  testOpsName: {
    fontWeight: theme.typography.fontWeightBold,
  },
  licenseInfo: {
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(0.5),
  },
  separateDot: {
    fill: '#D1D5DB',
    fontSize: theme.spacing(1),
    marginLeft: theme.spacing(3.25),
    marginRight: theme.spacing(3.25),
  },
  count: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));

interface TestOpsMemberLicenseProps {
  testResultCount: TestResultCount | null;
  countTestOpsProjects: number | null;
  orgId: string | null;
}

const TestOpsMemberLicense = (props: TestOpsMemberLicenseProps) => {
  const { testResultCount, countTestOpsProjects, orgId } = props;
  const classes = useStyles();
  const intl = useIntl();
  const { config } = useConfig();

  // unlimited plans: TO Trial Business/Enterprise.
  const isUnlimited = testResultCount?.subscriptionSource === SubscriptionSource.TRIAL;
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      className={classes.testopsLicenseContainer}
    >
      {/* License Info */}
      <Grid item>
        <Grid container alignItems="center">
          <TestOpsIcon className={classes.testopsIcon} />
          <Typography variant="subtitle2" className={classes.testOpsName}>
            {
              `${UsagePlan.getPlanFullName(testResultCount?.usagePlan)} ${testResultCount?.subscriptionSource === SubscriptionSource.TRIAL ? intl.formatMessage({ id: 'home.trial' }) : ''}`.trim()
            }
          </Typography>
        </Grid>
        <Grid
          container
          alignItems="center"
          className={classes.licenseInfo}
        >
          <Typography variant="subtitle2">
            <span className={classes.count}>
              { isUnlimited ? intl.formatMessage({ id: 'home.testops.unlimited' }) : intl.formatNumber(testResultCount?.quota || DEFAULT_EXECUTIONS) }
            </span>
            {
              intl.formatMessage({ id: 'home.testops.executions' }, { count: isUnlimited ? UNLIMITED_EXECUTIONS : testResultCount?.quota })
            }
          </Typography>
          <FiberManualRecordIcon fontSize="small" className={classes.separateDot} />
          <Typography variant="subtitle2">
            <span className={classes.count}>{ intl.formatNumber(countTestOpsProjects || 0) }</span>
            { intl.formatMessage({ id: 'home.testops.projects' }, { count: countTestOpsProjects }) }
          </Typography>
        </Grid>
      </Grid>
      <Button
        variant="contained"
        color="primary"
        component={RouterLink}
        to={resolvePath(sso, undefined, { redirect_uri: `${config?.testOpsPublicUrl}/organization/${orgId}/home` })}
      >
        <FormattedMessage id="home.go_to_testops_homepage" />
      </Button>
    </Grid>
  );
};
export default TestOpsMemberLicense;
